import { DefaultButton, Dialog, PrimaryButton, Stack, TextField } from "office-ui-fabric-react";
import { useState } from "react";
import { editFloorplanMetadata } from "../../../api/floorplans";
import { IFloorplan } from "../../../types/SiteLocation.types";

export interface IFloorplanFormProps {
    floorplan: Partial<IFloorplan>;
    onDismiss: (reloadFloorplans?: boolean) => void;
}

export const FloorplanForm = (props: IFloorplanFormProps) => {
    const [ name, setName ] = useState<string|undefined>(props.floorplan.Name);

    const _editFloorplanData = async (floorplan: IFloorplan) => {
        const response = await editFloorplanMetadata(floorplan);
        if (response instanceof Error) {
            console.error(response);
        } else if (response.ok) {
            props.onDismiss(true);
        } 
    };

    return (
        <Dialog hidden={false} dialogContentProps={{
            title: "Rename",
            showCloseButton: true,
            onDismiss: () => props.onDismiss(false),
        }}>
            <TextField label="Floorplan Name" value={name} onChange={(e, newValue) => setName(newValue)} />
            <Stack horizontalAlign="end" horizontal style={{margin: 20}}>
                <PrimaryButton disabled={!name || name.trim() === ""} iconProps={{iconName: "Save"}} text="Save" onClick={() => _editFloorplanData({...props.floorplan, Name: name as string} as IFloorplan)} style={{marginRight: 20}}/>
                <DefaultButton iconProps={{iconName: "Cancel"}} text="Cancel" onClick={() => props.onDismiss(false)} />
            </Stack>
        </Dialog>
    )
}